import { Box, Flex } from 'rebass'

import { FieldError } from '../shared/styledComponents'
import type { HelpProps } from '../shared/types'
import type { ClaimInputProps } from './types'

const ShowHelpInputWrapper = (
  Component: React.ElementType,
  Help: (props: HelpProps) => JSX.Element,
  pageName = 'claim-help'
) => {
  const HelpInputWrapper = ({
    disabled,
    children,
    id,
    input,
    label,
    placeholder,
    type,
    meta: {
      touched,
      error
    },
    helpText,
    helpHeader,
    ...attrs
  }: ClaimInputProps) => (
    <Flex flexWrap='wrap'>
      <Box width={[1, 1 / 3]} >
        <label htmlFor={id}>{label}</label>
        <Help
          source="claim_find"
          claimHelp={helpText}
          claimHeader={helpHeader}
          pageName={pageName}
        />
      </Box>
      <Box width={[1, 1 / 2]} >
        <Component
          disabled={disabled}
          error={touched && error}
          id={id}
          placeholder={placeholder}
          type={type}
          { ...input }
          {...attrs}
        >
          {children}
        </Component>
        <FieldError>{touched && error && <span>{error}</span>}</FieldError>
      </Box>
    </Flex>
  )
  return HelpInputWrapper
}

export {
  ShowHelpInputWrapper
}
